import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/ui/components/ui/card";

export const ExportInfo: React.FC = () => {
  const { t } = useTranslation("export");

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">{t("info.title")}</CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        <div>{t("info.sheets")}</div>
        <ul className="ml-4 space-y-1">
          <li>{t("info.sheetEvents")}</li>
          <li>{t("info.sheetTruckCycles")}</li>
          <li>{t("info.sheetAlerts")}</li>
        </ul>
        <div className="pt-2">{t("info.linkValidity")}</div>
        <div>{t("info.autoDownload")}</div>
      </CardContent>
    </Card>
  );
};
